var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHealthWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4146_115406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4538 2.70491L2.70497 15.4537C1.09186 17.0668 1.09186 19.6822 2.70497 21.2953L2.7053 21.2956C4.31841 22.9087 6.93378 22.9087 8.54689 21.2956L21.2957 8.54683C22.9088 6.93372 22.9088 4.31835 21.2957 2.70524L21.2954 2.70491C19.6823 1.0918 17.0669 1.0918 15.4538 2.70491Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1702 10.5415L13.4579 6.82921C12.8721 6.24343 11.9223 6.24343 11.3366 6.82921L6.96134 11.2044C6.37555 11.7902 6.37555 12.74 6.96134 13.3258L10.6736 17.0381C11.2594 17.6238 12.2092 17.6238 12.795 17.0381L17.1702 12.6628C17.756 12.0771 17.756 11.1273 17.1702 10.5415Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 9.75C11.75 9.61193 11.8619 9.5 12 9.5C12.1381 9.5 12.25 9.61193 12.25 9.75C12.25 9.88807 12.1381 10 12 10C11.8619 10 11.75 9.88807 11.75 9.75Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12C14 11.8619 14.1119 11.75 14.25 11.75C14.3881 11.75 14.5 11.8619 14.5 12C14.5 12.1381 14.3881 12.25 14.25 12.25C14.1119 12.25 14 12.1381 14 12Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12C9.5 11.8619 9.61193 11.75 9.75 11.75C9.88807 11.75 10 11.8619 10 12C10 12.1381 9.88807 12.25 9.75 12.25C9.61193 12.25 9.5 12.1381 9.5 12Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15C12.4142 15 12.75 14.6642 12.75 14.25C12.75 13.8358 12.4142 13.5 12 13.5C11.5858 13.5 11.25 13.8358 11.25 14.25C11.25 14.6642 11.5858 15 12 15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4146_115406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHealthWhite);
export default __webpack_public_path__ + "static/media/icon_health_white.d6ccecc484145bb837abc3536b12390d.svg";
export { ForwardRef as ReactComponent };